import { post } from '../../utils/api-utils'

export const sendFormData = (formData, accessToken) => {
  return post(
    '/platform-support-frontend-service/v1/feedback/submit',
    formData,
    accessToken
  )
}
